var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"width":"100%","height":"450","src":_vm.urlVideo,"frameborder":"0","allow":_vm.allowVideoOptions,"allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }